// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
  var headerHeight = $("header").innerHeight(); // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function ($) {
  var $header = $(".l-header");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 50) {
      $header.addClass("fixed");
    } else {
      $header.removeClass("fixed");
    }
  });
});

// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function ($) {
  if ($(".js-image-switch").length > 0) {
    var $elem = $(".js-image-switch");
    var sp = "_sp.";
    var pc = "_pc.";
    // 画像を切り替えるウィンドウサイズ // Window size to switch images
    var replaceWidth = 768;

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
          $this.attr("src", $this.attr("src").replace(sp, pc));
        } else {
          $this.attr("src", $this.attr("src").replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        imageSwitch();
      }, 200);
    });
  }
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function ($) {
  if ($("#pageplugin").length > 0) {
    var windowWidth = $(window).width();
    var htmlStr = $("#pageplugin").html();
    var timer = null;
    $(window).on("resize", function () {
      var resizedWidth = $(window).width();
      if (windowWidth != resizedWidth && resizedWidth < 500) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          $("#pageplugin").html(htmlStr);
          window.FB.XFBML.parse();
          //window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
          var windowWidth = $(window).width();
        }, 500);
      }
    });
  }
});

// tab
jQuery(function ($) {
  $(".js-tabBtn").on("click", function () {
    let index = $(".js-tabBtn").index(this);

    $(".js-tabBtn").removeClass("active");
    $(this).addClass("active");
    $(".js-tabCont").removeClass("active");
    $(".js-tabCont").eq(index).addClass("active");
  });
});
jQuery(function ($) {
  $(".js-tabBtn01").on("click", function () {
    let tabId = $(this).data("tab");
    let tabContainer = $(this).closest(".c-tab");

    tabContainer.find(".js-tabBtn01").removeClass("active");
    $(this).addClass("active");
    tabContainer.find(".js-tabCont01").removeClass("active");
    tabContainer.find(`.js-tabCont01[data-tab=${tabId}]`).addClass("active");
  });
});

jQuery(function ($) {
  $(".js-more").on("click", function () {
    $(this).toggleClass("active");
    $(".js-moreCont").slideToggle(1000);
  });
});

// Modal slider
jQuery(function ($) {
  $(document).ready(function () {
    const openModalBtns = $(".js-open-modal");
    const closeModalBtns = $(".js-close-modal");

    // Swiper configuration
    const swiperModals = {};

    openModalBtns.click(function () {
      const modalId = $(this).data("modal-id");
      const modalIndex = $(this).data("slide-index");
      const modal = $("#" + modalId);

      // Initialize swiper if not already initialized
      if (!swiperModals[modalId]) {
        swiperModals[modalId] = new Swiper("#" + modalId + " .swiperModal", {
          loop: true,
          slidesPerView: 1,
          allowTouchMove: false,
          navigation: {
            nextEl: "#" + modalId + " .swiper-button-next",
            prevEl: "#" + modalId + " .swiper-button-prev",
          },
          on: {
            slideChange: function () {
              // 内側のスライダーインスタンスを取得
              var innerSlider = this.slides[this.activeIndex].querySelector(".swiperThumb").swiper;
              // 内側のスライダーを1枚目にスライド
              innerSlider.slideTo(0, 0);
            },
          },
        });
      }

      swiperModals[modalId].slideTo(modalIndex);
      modal.addClass("is-active");
    });

    closeModalBtns.click(function () {
      const modalId = $(this).closest(".modal").attr("id");
      const modal = $("#" + modalId);
      modal.removeClass("is-active");
    });
  });

  const swiperThumb = new Swiper(".swiperThumb", {
    speed: 1000, // スライド変化時間
    slidesPerView: 1,
    nested: true,
    pagination: {
      el: ".swiper-thumb-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-thumb-next",
      prevEl: ".swiper-thumb-prev",
    },
  });
});

// Display more articles
jQuery(function ($) {
  $(document).ready(function () {
    const buttonsToShowInitially = 6;
    const buttonsToShowClick = 50;
    let currentButtonCounts = {};

    $(".c-tab__pane").each(function () {
      const tabId = $(this).data("tab");
      currentButtonCounts[tabId] = buttonsToShowInitially;
      $(this)
        .find(".c-modal__button:lt(" + buttonsToShowInitially + ")")
        .show();
    });

    $(".js-showMore").on("click", function (e) {
      e.preventDefault();

      const tabId = $(this).closest(".c-tab__pane").data("tab");

      for (let i = currentButtonCounts[tabId]; i < currentButtonCounts[tabId] + buttonsToShowClick; i++) {
        $(".c-tab__pane[data-tab='" + tabId + "'] .c-modal__button:eq(" + i + ")").slideDown();
      }
      currentButtonCounts[tabId] += buttonsToShowClick;

      const buttonNum = $(".c-tab__pane[data-tab='" + tabId + "'] .c-modal__button");
      if (buttonNum.length == buttonNum.filter(":visible").length) {
        $(this).fadeOut();
      }
    });
  });
});

//Display more Content
// jQuery(function ($) {
//   $(document).ready(function () {
//     $(".js-showListBtn").on("click", function () {
//       $(".js-showListBtn").closest(".p-mallResult__link").toggleClass("is-active");
//       $(".js-moreListContent").toggleClass("active");
//       const buttonText = $(this).text() === "一覧を見る" ? "閉じる" : "一覧を見る";
//       $(this).text(buttonText);
//     });
//   });
// });

jQuery(function ($) {
  var $btn = $(".p-downloadCat [data-filter]"),
    $list = $(".p-downloadList [data-category]");

  $btn.on("click", function (e) {
    e.preventDefault();
    $(".p-downloadCat a").removeClass("active");
    $(this).addClass("active");

    var $btnTxt = $(this).attr("data-filter");

    if ($btnTxt == "all") {
      $list
        .fadeOut()
        .promise()
        .done(function () {
          $list.fadeIn();
        });
    } else {
      $list
        .fadeOut()
        .promise()
        .done(function () {
          $list.filter('[data-category = "' + $btnTxt + '"]').fadeIn();
        });
    }
  });
});

jQuery(function ($) {
  var width = $(window).width();
  if (width <= 1116) {
    $(".l-header-nav__item--parent>a").off("click");
    $(".l-header-nav__item--parent>a").click(function () {
      // var parentElem = $(this).parent();
      // $(parentElem).toggleClass("active");
      $(".l-header-nav__sub__sp").slideToggle();
      return false;
    });
  }
});

jQuery(function ($) {
  if ($(".c-fixCta").length > 0) {
    var fixCta = $(".c-fixCta");
    fixCta.css("display", "none");
    //スクロールが100に達したらボタン表示 // display button when scroll reaches 100
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        fixCta.fadeIn();
      } else {
        fixCta.fadeOut();
      }
    });
  }
});
